
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { IFaq } from '~/data/faqs';

@Component
export default class FaqsList extends Vue {
  @Prop({ type: String, default: 'div' })
  readonly tag!: keyof HTMLElementTagNameMap;
  @Prop(String)
  readonly heading?: string;
  @Prop(String)
  readonly showMoreText?: string;
  @Prop(String)
  readonly showLessText?: string;
  @Prop(Array)
  readonly faqs!: Array<IFaq>;
  @Prop({ type: Number, default: 6 })
  limit!: number;

  showAll = false;
  showAlways: Array<IFaq> = [];
  showMore: Array<IFaq> = [];

  created() {
    if (this.limit <= 0) {
      this.showAlways = this.faqs;
    } else {
      this.faqs?.forEach((faq, i) =>
        i < this.limit ? this.showAlways.push(faq) : this.showMore.push(faq),
      );
    }
  }

  toggleShowAll() {
    this.showAll = !this.showAll;
  }

  @Watch('faqs')
  onFaqsChange() {
    if (this.limit <= 0) {
      this.showAlways = this.faqs;
    } else {
      this.faqs?.forEach((faq, i) =>
        i < this.limit ? this.showAlways.push(faq) : this.showMore.push(faq),
      );
    }
  }
}
